import { moduleProviderFactory } from "core/providers";
import { 
	FacilityOrderList, 
	FacilityOrderEdit, 
	FacilityOrderEditCsv,
	FacilityOrderTemplateList,
	FacilityOrderTemplateEdit,
	FacilityOrderTemplatePatientCreate,
	FacilityInventoryCalculationItemList,
	InventoryCalculationCutbackEdit,
	FacilityOrderAdjustNextRunDates
 } from "application/facility-order/pages";

 import { PickTicketDetailList } from "application/pick-ticket/pages";

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.facility-order",
				pattern: "/facility-orders",
				children: [
					{
						name: "master.app.main.facility-order.list",
						pattern: "",
						tabTitle: 'FACILITY_ORDER.LIST.TITLE',
						component: FacilityOrderList,
						authorization: "facilityOrderSection.read",
						data: {
							title: "FACILITY_ORDER.LIST.TITLE",
						},
					},
					{
						name: "master.app.main.facility-order.create",
						pattern: "/create",
						tabTitle: 'Create Facility Order',
						component: FacilityOrderEdit,
						authorization: "facilityOrderSection.create",
						data: {
							back: "master.app.main.facility-order.list",
							title: "FACILITY_ORDER.EDIT.TITLE",
						},
					},
					{
						name: "master.app.main.facility-order.create-csv",
						pattern: "/create-csv",
						tabTitle: 'Create Facility Order',
						component: FacilityOrderEditCsv,
						authorization: "facilityOrderSection.create",
						data: {
							back: "master.app.main.facility-order.list",
							title: "FACILITY_ORDER.EDIT.TITLE",
						},
					},
					{
						name: "master.app.main.facility-order.edit",
						pattern: "/edit/:id",
						component: FacilityOrderEdit,
						authorization: "facilityOrderSection.update",
						data: {
							back: "master.app.main.facility-order.list",
							title: "FACILITY_ORDER.EDIT.TITLE",
						},
					},
					{
						name: "master.app.main.facility-order.facility-order-template.list",
						pattern: "/:id/templates",
						authorization: "facilityOrderSection.read",
						component: FacilityOrderTemplateList,
						data: {
							back: "master.app.main.facility-order.list",
							title: "FACILITY_ORDER_TEMPLATE.LIST.TITLE",
							crumbs: {
								title: "FACILITY_ORDER.CRUMB.TEMPLATES",
								route: 'master.app.main.facility-order.facility-order-template.list'
							}
						},
					},
					{
						name: "master.app.main.facility-order.facility-order-template.edit",
						pattern: "/:facilityOrderId/patient-templates/edit/:patientId/patient-key/:patientKey",
						component: FacilityOrderTemplateEdit,
						authorization: "facilityOrderSection.update",
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.TEMPLATES",
									route: 'master.app.main.facility-order.facility-order-template.list'
								},
								{
									title: "FACILITY_ORDER.CRUMB.PATIENT_TEMPLATES",
									route: 'master.app.main.facility-order.facility-order-template.edit'
								}
							]
						},    
					},
					{
						name: "master.app.main.facility-order.facility-order-template.create-patient",
						pattern: "/:facilityOrderId/create-patient",
						tabTitle:'Create New Patient',
						component: FacilityOrderTemplatePatientCreate,
						authorization: "facilityOrderSection.create",
						data: {
							back: "master.app.main.facility-order.facility-order-template.list",
						},
					},
					{
						name: "master.app.main.facility-order.facility-inventory-calculation-items.list",
						pattern: "/:facilityOrderId/facility-inventory-calculation-items",
						component: FacilityInventoryCalculationItemList,
						authorization: "facilityOrderSection.create",
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.TEMPLATES",
									route: 'master.app.main.facility-order.facility-order-template.list'
								},
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY_CALCULATION",
									route: 'master.app.main.facility-order.facility-inventory-calculation-items.list'
								}
							],
							back: "master.app.main.facility-order.facility-order-template.list",
						},
					},
					{
						name: "master.app.main.facility-order.inventory-calculation-cutback.edit",
						pattern: "/:facilityOrderId/inventory-calculation-cutback/:id/isCutback/:isCutback",
						tabTitle:'Edit Inventory Calculation',
						component: InventoryCalculationCutbackEdit,
						authorization: "facilityOrderSection.update",
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.TEMPLATES",
									route: 'master.app.main.facility-order.facility-order-template.list'
								},
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY_CALCULATION",
									route: 'master.app.main.facility-order.facility-inventory-calculation-items.list'
								},
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY_CALCULATION_EDIT",
									route: 'master.app.main.facility-order.inventory-calculation-cutback.edit'
								}
							],
							back: "master.app.main.facility-order.facility-inventory-calculation-items.list",
						},
					},
					{
						name: "master.app.main.facility-order.pick-ticket.list",
						pattern: "/:facilityOrderId/pick-ticket/:pickTicketHeaderId",
						authorization: "facilityOrderSection.read",
						component: PickTicketDetailList,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.TEMPLATES",
									route: 'master.app.main.facility-order.facility-order-template.list'
								},
								{
									title: "FACILITY_ORDER.CRUMB.PICK_TICKET",
									route: 'master.app.main.facility-order.pick-ticket.list'
								}
							]
						},
					},
					{
						name: "master.app.main.facility-order.adjust-next-run-dates",
						pattern: "/:facilityOrderId/adjust-next-run-dates",
						tabTitle:'Adjust Next Run Dates',
						component: FacilityOrderAdjustNextRunDates,
						authorization: "facilityOrderSection.update",
						data: {
							title: 'Adjust Next Run Dates',
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.TEMPLATES",
									route: 'master.app.main.facility-order.facility-order-template.list'
								},
								{
									title: "FACILITY_ORDER.CRUMB.ADJUST_NEXT_RUN_DATES",
									route: 'master.app.main.facility-order.adjust-next-run-dates'
								}
							]
						},
					},
				],
			},
		],
		menu: [
			{
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: 'coreUserSection.read',
				order: 5,
				subMenu: [
					{
						title: 'MENU.FACILITY_ORDERS_SUB_DAVID',
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.list",
						order: 1,
					}  
				]
			},
		],
	});
})();